import * as services from './addcertificates.service'
import {
  UpdateCertificate
} from './addcertificates.service';
export default {

  data() {
    return {
      //coloumns and properties for certificate list
      compliance_columns: ['CertificateName', 'CertificateAgency', 'Number', 'Instructor', 'IssueDate', 'ExpiryDate', 'Actions'],
      agency_columns: ['CertificateAgencyName'],
      optionstreetable: {
        headings: {
          CertificateAgencyName: 'Agency Name',
        }
      },

      optionstable: {
        skin: this.$hydrowareCommonJS.hydrowareTableSkin,
        headings: {
          CertificateName: 'Certification Name',
          CertificateAgency: 'Agency Name',
          Number: 'Number',
          Instructor: 'Instructor',
          IssueDate: 'Issue Date',
          ExpiryDate: 'Expiry Date',
          Actions: ''
        },
        labelPosition: 'top',
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        sortable: ['IssueDate','ExpiryDate'],
        orderBy: {
          column: 'ExpiryDate',
          ascending: true //FG - FOOF - After Cert - First Release (3) - this had been sorting in the opposite direction, now it shows cert that is expiring soonest at the top by default
        },
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },
      //object used for passing while adding a certificate
      Certificate: {
        'PersonnelId': '',
        'CertificationId': '',
        'Number': '',
        'Instructor': '',
        'ExpiryDate': '',
        'IssueDate': '',
        'Attachments': [],
        'Id': ''
      },
      CertificateEditID: '',
      ChangedAttachFiles: '',
      CertificateList: [],
      AgencyCertificateList: [],
      certificateexpirationtime: '',
      certificateexpirationstatus: '',
      selectedcertificates: '',
      selectedagency: '',
      editselectedagency: '',
      editissuedate: '',
      issuedate: '',
      image_data: [],
      attachedfiles: [],
      Attachments: [],
      certificateslistperperson: [],
      AgencyList: '',
      isadding: false,
      isediting: false,
      isviewing: true,
      activestatus: true,
      pid: '',
      isself: false,//FG - FOOF - After Cert - First Release Security
      url: 'http://dev-hydronew.azurewebsites.net/api/Documents/CertificationDocuments/',
      //FG - FOOF - added var below
      copyOfCertBeingEdited: null

    }
  },
  //props: ['data'], //FG - FOOF - replaced this line with the line belo
  props: ['data', 'editShow', 'showInitialView'],
  mounted() {
    if (this.$route.params.id) {
      this.pid = this.$route.params.id
      this.getAllCertificateLists();
    }
    this.image_data = []
    this.image_data = new FormData()
    // this.getAllAgencyCertificates()
    this.getAllCertificateListsandAgency()
    //FG - FOOF - After Cert - First Release Security - added line below
    this.isself = (this.pid == JSON.parse(localStorage.getItem('authentication')).PersonnelId) ? true : false
    this.viewCertificates();
  },
  methods: {
    addCertificates() {
      this.isadding = true
      this.Certificate = {
        'CertificationId': '',
        'Number': '',
        'Instructor': '',
        'ExpiryDate': '',
        'IssueDate': '',
        'Attachments': [],
        'Id': ''
      }

    },
    getAllCertificateLists() {
      let context = this;
      services.GetCertificateList(this.pid).then(function (response) {
        if (response != null)
          context.certificateslistperperson = response
        else
          context.certificateslistperperson = []
      }), (error) => {

      }

    },
    getAllCertificateListsandAgency() {
      let context = this;
      services.GetCertificateAgencyTree().then(function (response) {

        context.AgencyCertificateList = []
        var data = deepcopy(response)
        data.filter(function (item) {
          item.IsActive = true
          context.AgencyCertificateList.push(item)
        })
        context.selectedcertificates = context.AgencyCertificateList[0].CertificateNameId
        context.AgencyList = context.AgencyCertificateList[0].Agencies
        context.selectedagency = context.AgencyList[0].CertificateId
      })
    },

    editCertificates(item) {
     this.editShow = true
     this.isediting=true
     this.isadding=false
     this.isviewing=false
    },

    viewCertificates() {//show the table of certs (all of 'em)
    this.editShow = false
    this.isadding = false
    this.isediting = false
    this.isviewing = false
  },
    viewOneCertificate(item) {//show a single certificate from the table
      this.editShow = true
      this.copyOfCertBeingEdited = deepcopy(item)
      this.isviewing = true
      let context = this
      this.image_data = []
      this.image_data = new FormData()
      var certificateedit = item.row
      this.editissuedate = certificateedit.IssueDate
      this.editselectedagency = certificateedit.CertificationId
      this.selectedcertificates = certificateedit.OrgCertificateNameId
      this.isediting = false
      this.isadding  = false
      
      this.CertificateEditID = certificateedit.Id
      this.Certificate = certificateedit
      this.issuedate = certificateedit.IssueDate
      // this.formatExpiryDate(dateval)
      this.Attachments = certificateedit.AttachedFiles
      setTimeout(function () {}, 6000);
    },
    resetPlease() {
      this.viewOneCertificate(this.copyOfCertBeingEdited)        
    },
    updatecertificates() {
      let context = this;
      this.Certificate.CertificationId = this.selectedcertificates
      this.Certificate.IssueDate = context.$options.filters.fdate(this.issuedate)
      this.Certificate.Attachments = this.Attachments
      this.Certificate.ExpiryDate = context.$options.filters.fdate(this.Certificate.ExpiryDate)
      services.UpdateCertificate(this.Certificate)
    },
    deleteCertificate(item) {
      let context = this
      /*
      FG - FOOF - After Cert - First Release (5) - made the prompt more specific by adding the cert name
      */
      context.$confirm('Are you sure you want to delete the '+ item.row.CertificateName + ' certificate?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        loader.startLoader()
        services.DeleteCertificateList(item.row.Id).then(function (response) { //added response as the returned value it had been ()         
        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                    
          loader.stopLoader()
          return;
        }

          context.getAllCertificateLists()
          loader.stopLoader()
          context.$notify({
            title: 'Deleted',
            message: 'Deleted Successfully',
            type: 'success'
          })
        }), (error) => {
          loader.stopLoader()
          this.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })
        }
      }).catch(() => {

      })

    },
    loadCertificates(id) {
      let context = this;
      this.AgencyCertificateList.filter(function (item) {

        if (item.CertificateNameId == id) {
          context.AgencyList = item.Agencies
          if (context.editselectedagency != "") {
            context.selectedagency = context.editselectedagency
          } else {
            context.selectedagency = context.AgencyList[0].CertificateId
          }
          context.editselectedagency = ""

        }
      })
    },
    getExpirationYear() {
      let context = this;
      this.AgencyList.filter(function (item) {
        if (item.CertificateId == context.selectedcertificates)
          context.certificateexpirationtime = item.ExpiryPeriod
        context.certificateexpirationstatus = item.ExpiryStatus
      })
    },
    setAttachment(e) {
      let context = this

      function getExtension(filename) {
        var parts = filename.split('.')
        return parts[parts.length - 1]
      }

      for (var i = 0; i < e.target.files.length; i++) {
        var name = e.target.files[i].name
        var type = e.target.files[i].type
        var size = e.target.files[i].size

        if (type != 'image/jpeg' && type != 'image/jpg' && type != 'image/png' && getExtension(name) != 'docx' && getExtension(name) != 'doc' && getExtension(name) != 'txt' && getExtension(name) != 'pdf') {
          alert('Invalid file format')
          return
        }
        if (size == 0) {
          alert('File is Empty')
          return
        }
        if (size > 5000000) {
          alert('You have exceeded the maximum image size of 5 MB')
          return
        }
        var id = i
        this.image_data.append('Attachments[' + i + ']', e.target.files[i])
        this.Attachments.push({
          FileName: name,
          MediaType: type,
          id: id,
        })

      }
    },
    removeattachedtag(tag) {
      let context = this
      let ps = []
      for (var i = 0; i < this.Attachments.length; i++) {
        if (this.Attachments[i].id == tag.id) {
          this.image_data.delete('Attachments[' + i + ']')
          for (var j = 0; j < this.Attachments.length; j++) {
            var files = this.image_data.getAll('Attachments[' + j + ']')
            if (files.length > 0) {
              $.each(files, function (h, v) {
                ps.push(v)
              })
            }
          }
          this.Attachments.splice(i, 1)
          break
        }
      }
      if (ps.length > 0) {
        this.image_data = []
        this.image_data = new FormData()
        for (var k = 0; k < ps.length; k++) {
          this.image_data.append('Attachments[' + k + ']', ps[k])
        }
      }
    },
    removeeditattachmnets(tag) {
      for (var i = 0; i < this.Attachments.length; i++) {
        if (this.Attachments[i].DocumentPath == tag.DocumentPath) {
          this.Attachments.splice(i, 1)
          break
        }
      }
      for (var i = 0; i < this.addDocument.ComplianceDocumentFiles.length; i++) {
        if (this.addDocument.ComplianceDocumentFiles[i].Id == tag.Id) {
          this.DocIds.splice(i, 1)
          break
        }
      }
    },
    createCertificates() {
      var image_arr = {}
      let context = this;
      if (context.Certificate.Instructor) {
        image_arr['Instructor'] = context.Certificate.Instructor
      } else {
        image_arr['Instructor'] = ''
      }

      if (context.issuedate) {
        //  var formatdate= context.issuedate.split("-");
        image_arr['IssueDate'] = context.$options.filters.fdate(context.issuedate)
      } else {
        image_arr['IssueDate'] = ''
      }

      if (context.Certificate.Number) {
        image_arr['Number'] = context.Certificate.Number
      } else {
        image_arr['Number'] = ''
      }

      if (context.Certificate.ExpiryDate) {
        // context.$options.filters.fdate(context.Certificate.ExpiryDate)
        image_arr['ExpiryDate'] = context.Certificate.ExpiryDate
      } else {
        image_arr['ExpiryDate'] = ''
      }
      if (context.pid) {
        image_arr['PersonnelId'] = context.pid
      } else {
        image_arr['PersonnelId'] = ''
      }
      if (context.selectedagency) {
        image_arr['CertificationId'] = context.selectedagency
      } else {
        image_arr['CertificationId'] = ''
      }
      for (var key in image_arr) {

        this.image_data.append(key, image_arr[key])
      }
      services.AddCertificate(this.image_data).then(function (response) {   
        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                    
          loader.stopLoader()
          return;
        }
    
        context.image_data = new FormData()
        context.getAllCertificateLists()
        loader.stopLoader()
        context.$notify({
          title: 'Success',
          message: 'Certificate Added',
          type: 'success'
        })
        context.isadding = false
      }, (error) => {

        for (var key in image_arr) {
          context.image_data.delete(key, image_arr[key])
        }

        loader.stopLoader()
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })

    },
    UpdateCertificate() {
      var image_arr = {}
      var filenames = []
      let context = this;
      for (var i = 0; i < this.Attachments.length; i++) {
        if (context.Attachments[i].RealFileName)
          filenames.push(context.Attachments[i].DocumentPath);
      }
      var AttachedFiles = filenames.join(",")

      if (context.Certificate.Instructor) {
        image_arr['Instructor'] = context.Certificate.Instructor
      } else {
        image_arr['Instructor'] = ''
      }

      if (context.issuedate) {
        image_arr['IssueDate'] = context.$options.filters.fdate(context.issuedate)
      } else {
        image_arr['IssueDate'] = ''
      }

      if (context.Certificate.Number) {
        image_arr['Number'] = context.Certificate.Number
      } else {
        image_arr['Number'] = ''
      }

      if (context.Certificate.ExpiryDate) {
        image_arr['ExpiryDate'] = context.$options.filters.fdate(context.Certificate.ExpiryDate)
      } else {
        image_arr['ExpiryDate'] = ''
      }
      if (context.pid) {
        image_arr['PersonnelId'] = context.pid
      } else {
        image_arr['PersonnelId'] = ''
      }
      if (context.selectedagency) {
        image_arr['CertificationId'] = context.selectedagency
      } else {
        image_arr['CertificationId'] = ''
      }
      if (AttachedFiles) {
        image_arr['ChangedAttachFiles'] = AttachedFiles
      } else {
        image_arr['ChangedAttachFiles'] = ''
      }
      if (context.CertificateEditID) {
        image_arr['Id'] = context.CertificateEditID
      } else {
        image_arr['Id'] = ''
      }
      for (var key in image_arr) {

        this.image_data.append(key, image_arr[key])
      }

      services.UpdateCertificate(this.image_data).then(function (response) {
        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                    
          loader.stopLoader()
          return;
        }
        context.image_data = new FormData()
        context.getAllCertificateLists()
        loader.stopLoader()
        context.$notify({
          title: 'Success',
          message: 'Certificate Updated',
          type: 'success'
        })
        context.isediting = false
      }), (error) => {
        loader.stopLoader()
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      }
    },
    backProfile() {
      this.$router.push('/addpersonnel')

    },
    getFormattedDate(date) {
      var year = date.getFullYear();

      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;

      return month + '/' + day + '/' + year;
    },
    changeStatus(item) {

      var message = '';
      var successmsg = ''
      if (item.IsActive == true) {
        message = ' Are you sure you want to deactivate this certificate'
        successmsg = 'Deactivated the Certificate'
      } else {
        message = 'Are you sure you want to activate this certificate'
        successmsg = 'Activated the Certificate'
      }
      let context = this
      context.$confirm(message, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        loader.startLoader()
        services.ChangeStatus(item.Id, !item.IsActive).then(function (response) {
          context.getAllCertificateLists()
          loader.stopLoader()
          context.$notify({
            title: 'Success',
            message: successmsg,
            type: 'success'
          })
        }), (error) => {
          loader.stopLoader()
          context.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })
        }
      }).catch(() => {

      })
    },
    downloadattachment(file) {

      let context = this
      var downloadurl = window.baseUrl + 'Documents/CertificationDocuments/' + file.DocumentPath
      window.open(downloadurl, '_blank')
    },
    formatExpiryDate(dateval) {
      var year = dateval.getFullYear();
      var month = (1 + dateval.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;
      var day = dateval.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      var date = month + '-' + day + '-' + year;
      this.Certificate.ExpiryDate = date.toString();
    },

  },
  watch: {
    showInitialView: function() {
      //alert("SHOW INITIAL VIEW: " + this.showInitialView)
      let context = this;
      if(context.showInitialView == true) {
        context.viewCertificates();
        context.showInitialView = false;
      }
    },
    selectedcertificates: function (val) {
      this.loadCertificates(val)
    },
    selectedagency: function (val) {
      if (this.editissuedate != "") {
        this.issuedate = this.editissuedate
      } else {
        this.issuedate = ""
      }
      this.editissuedate = ""
    },
    issuedate: function (val) {
      let context = this

      if (val != "") {
        var dateval = new Date(val)
        this.AgencyList.filter(function (item) {
          if (item.CertificateId == context.selectedagency) {
            context.certificateexpirationtime = item.ExpiryPeriod
            context.certificateexpirationstatus = item.ExpiryStatus

            switch (context.certificateexpirationstatus) {
              case 'Years':
                {
                  dateval.setFullYear(dateval.getFullYear() + context.certificateexpirationtime);
                  context.formatExpiryDate(dateval)
                  break;
                }
              case 'Months':
                {
                  dateval.setMonth(dateval.getMonth() + context.certificateexpirationtime);
                  context.formatExpiryDate(dateval)
                  break;
                }
              case 'Days':
                {
                  dateval.setDate(dateval.getDate() + context.certificateexpirationtime);
                  context.formatExpiryDate(dateval)
                  break;
                }
              default:
                {
                  break;
                }
            }


          }
        })

      }
    },

  }

}



// WEBPACK FOOTER //
// ./src/components/Certificates/addcertificates.controller.js